import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "dineflo_customer_token";

export const getCustomerToken = () => localStorage.getItem(TOKEN_KEY);
export const setCustomerToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearCustomerToken = () => localStorage.removeItem(TOKEN_KEY);

// Authorization header for public endpoints that optionally link a customer.
export const authHeader = () => {
  const t = getCustomerToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const customerApi = {
  register: (body) => axios.post(`${API}/customer/auth/register`, body),
  login: (body) => axios.post(`${API}/customer/auth/login`, body),
  me: () => axios.get(`${API}/customer/auth/me`, { headers: authHeader() }),
  orders: () => axios.get(`${API}/customer/orders`, { headers: authHeader() }),
  bookings: () => axios.get(`${API}/customer/bookings`, { headers: authHeader() }),
};
